// Visual layout editor for sandboxed generated pages. Content stays read-only:
// the bridge only reorders existing DOM nodes, never edits text/attributes
// that affect meaning. Two steps, deliberately explicit rather than guessed:
//
//   1. PICKING — same interaction as the "Comment on something" picker
//      (lib/elementPicker.js): hover highlights a candidate card/section,
//      click confirms it. A ▲ nudge lets the creator widen the highlighted
//      area up one ancestor at a time, since no automatic heuristic reliably
//      guesses "the card" the creator means on every generated page.
//   2. ARRANGING — only the DIRECT children of the confirmed card become
//      draggable, and they can only ever reorder among themselves (plain
//      HTML5 drag-and-drop, insertBefore within that one parent). Nothing
//      can be dragged into a different card and no card's contents can leak
//      into another — the previous free-for-all across the whole page was
//      what was distorting generated pages.
//
// "Choose a different part" backs out to step 1 without losing anything
// already moved in a previous card during this same session.

const LAYOUT_EDITOR_SCRIPT = `<script id="ll-layout-editor-bridge">
(function () {
  var mode = 'off'; // 'off' | 'picking' | 'arranging'
  var card = null, candidate = null, dragged = null, dragFrom = null;
  var undoStack = [], redoStack = [];

  var hoverBox = document.createElement('div');
  hoverBox.setAttribute('data-ll-bridge-ui', 'layout');
  hoverBox.innerHTML = '<span class="ll-pick-label"></span><button type="button" class="ll-pick-widen" title="Select a bigger area">▲</button>';
  var pickLabel = hoverBox.firstChild, widenBtn = hoverBox.lastChild;

  function visible(el) {
    if (!el || el.nodeType !== 1 || el.closest('[data-ll-bridge-ui]')) return false;
    if (/^(html|body|script|style|link|meta|template|br)$/i.test(el.tagName)) return false;
    var r = el.getBoundingClientRect(), s = getComputedStyle(el);
    return r.width > 8 && r.height > 8 && s.display !== 'none' && s.visibility !== 'hidden';
  }
  function childCount(el) { return Array.prototype.filter.call(el.children, visible).length; }

  // Best-effort starting guess: the nearest ancestor-or-self with 2+ visible
  // children. The creator can widen from there with ▲, so a wrong guess is
  // never a dead end.
  function nearestCard(el) {
    var node = el;
    while (node && node !== document.documentElement) {
      if (childCount(node) >= 2) return node;
      if (node === document.body) return node;
      node = node.parentElement;
    }
    return el;
  }
  function labelFor(el) {
    if (el === document.body) return 'whole page';
    var text = (el.getAttribute('aria-label') || el.innerText || '').trim().replace(/\\s+/g, ' ').slice(0, 40);
    var n = childCount(el);
    return (text || el.tagName.toLowerCase()) + ' (' + n + (n === 1 ? ' part' : ' parts') + ')';
  }

  function positionHoverBox() {
    if (!candidate || !document.documentElement.contains(candidate)) { hoverBox.style.display = 'none'; return; }
    var r = candidate.getBoundingClientRect();
    hoverBox.style.cssText = 'display:block;position:fixed;z-index:2147483647;pointer-events:none;'
      + 'left:' + r.left + 'px;top:' + r.top + 'px;width:' + Math.max(20, r.width) + 'px;height:' + Math.max(20, r.height) + 'px;'
      + 'border:2px dashed #cc785c;background:rgba(204,120,92,.12);border-radius:6px;box-sizing:border-box;';
    pickLabel.textContent = labelFor(candidate);
    var canWiden = candidate !== document.body && candidate.parentElement;
    widenBtn.style.display = canWiden ? '' : 'none';
  }
  function showCandidate(el) { candidate = el; positionHoverBox(); }

  function startPicking() {
    mode = 'picking'; card = null; candidate = null;
    document.documentElement.appendChild(hoverBox);
    document.body.classList.add('ll-ve-picking');
    parent.postMessage({ __llLayoutMode: true, mode: 'picking' }, '*');
  }
  function stopPicking() {
    hoverBox.style.display = 'none';
    document.body.classList.remove('ll-ve-picking');
  }

  function enterArranging(chosen) {
    card = chosen;
    stopPicking();
    mode = 'arranging';
    var items = Array.prototype.filter.call(card.children, visible);
    items.forEach(function (el) {
      el.draggable = true;
      el.classList.add('ll-layout-movable');
      el.setAttribute('data-ll-layout-editing', 'true');
    });
    card.classList.add('ll-layout-card-active');
    card.setAttribute('data-ll-layout-card', 'true');
    undoStack = []; redoStack = [];
    parent.postMessage({ __llLayoutMode: true, mode: 'arranging', count: items.length, label: labelFor(card) }, '*');
    historyState();
  }
  function exitArranging() {
    if (!card) return;
    card.querySelectorAll('[data-ll-layout-editing]').forEach(function (el) {
      el.draggable = false;
      el.classList.remove('ll-layout-movable', 'll-layout-dragging');
      el.removeAttribute('data-ll-layout-editing');
      el.removeAttribute('draggable');
    });
    card.classList.remove('ll-layout-card-active');
    card.removeAttribute('data-ll-layout-card');
    card = null;
  }

  function historyState() {
    parent.postMessage({ __llLayoutHistory: true, undo: undoStack.length, redo: redoStack.length }, '*');
  }
  function recordMove(el, oldParent, oldNext, newParent, newNext) {
    undoStack.push({
      undo: function () { oldParent.insertBefore(el, oldNext && oldNext.parentNode === oldParent ? oldNext : null); },
      redo: function () { newParent.insertBefore(el, newNext && newNext.parentNode === newParent ? newNext : null); },
    });
    redoStack = [];
    historyState();
  }
  function action(type) {
    if (type === 'undo' && undoStack.length) { var u = undoStack.pop(); u.undo(); redoStack.push(u); }
    else if (type === 'redo' && redoStack.length) { var r = redoStack.pop(); r.redo(); undoStack.push(r); }
    else if (type === 'reset') { while (undoStack.length) { undoStack.pop().undo(); } redoStack = []; }
    else if (type === 'choose') { exitArranging(); startPicking(); }
    historyState();
  }

  // ── Step 1: picking ──────────────────────────────────────────────────
  document.addEventListener('mouseover', function (e) {
    if (mode !== 'picking' || e.target === widenBtn || e.target === pickLabel) return;
    if (candidate && candidate.contains(e.target)) return; // keep a manually-widened choice while hovering inside it
    showCandidate(nearestCard(e.target));
  }, true);
  document.addEventListener('click', function (e) {
    if (mode !== 'picking' || e.target.closest('[data-ll-bridge-ui]')) return;
    e.preventDefault(); e.stopPropagation();
    if (candidate) enterArranging(candidate);
  }, true);
  widenBtn.addEventListener('pointerdown', function (e) { e.preventDefault(); e.stopPropagation(); });
  widenBtn.addEventListener('click', function (e) {
    e.preventDefault(); e.stopPropagation();
    if (candidate && candidate !== document.body && candidate.parentElement) showCandidate(candidate.parentElement);
  });
  window.addEventListener('scroll', positionHoverBox, true);
  window.addEventListener('resize', positionHoverBox);

  // ── Step 2: arranging — reorder only, strictly within \`card\` ─────────
  document.addEventListener('dragstart', function (e) {
    if (mode !== 'arranging') return;
    var item = e.target.closest('.ll-layout-movable');
    if (!item || item.parentElement !== card) return;
    dragged = item; dragFrom = { parent: item.parentElement, next: item.nextSibling };
    item.classList.add('ll-layout-dragging');
    e.dataTransfer.effectAllowed = 'move';
    e.dataTransfer.setData('text/plain', 'move');
  }, true);
  document.addEventListener('dragover', function (e) {
    if (mode !== 'arranging' || !dragged) return;
    var target = e.target.closest('.ll-layout-movable');
    if (!target || target === dragged || target.parentElement !== card) return;
    e.preventDefault();
    var r = target.getBoundingClientRect(), cardRect = card.getBoundingClientRect();
    var horizontal = Math.abs(r.width - cardRect.width) > 40;
    var after = horizontal ? (e.clientX > r.left + r.width / 2) : (e.clientY > r.top + r.height / 2);
    card.insertBefore(dragged, after ? target.nextSibling : target);
  }, true);
  document.addEventListener('dragend', function () {
    if (dragged) {
      dragged.classList.remove('ll-layout-dragging');
      if (dragFrom && (dragFrom.parent !== dragged.parentElement || dragFrom.next !== dragged.nextSibling)) {
        recordMove(dragged, dragFrom.parent, dragFrom.next, dragged.parentElement, dragged.nextSibling);
      }
    }
    dragged = null; dragFrom = null;
  }, true);

  function cleanHtml() {
    var clone = document.documentElement.cloneNode(true);
    clone.querySelectorAll('#ll-layout-editor-bridge, #ll-layout-editor-style, [data-ll-bridge-ui]').forEach(function (el) { el.remove(); });
    clone.querySelectorAll('script').forEach(function (s) {
      var t = s.textContent || '';
      if (t.indexOf('__llPicker') >= 0 || t.indexOf('__llAskAI') >= 0 || t.indexOf('__llLayout') >= 0) s.remove();
    });
    ['ll-layout-movable', 'll-layout-dragging', 'll-layout-card-active', 'll-ve-picking'].forEach(function (cls) {
      clone.querySelectorAll('.' + cls).forEach(function (el) {
        el.classList.remove(cls);
        if (!el.className) el.removeAttribute('class');
      });
    });
    clone.querySelectorAll('[data-ll-layout-editing],[data-ll-layout-card]').forEach(function (el) {
      el.removeAttribute('data-ll-layout-editing');
      el.removeAttribute('data-ll-layout-card');
      el.removeAttribute('draggable');
    });
    return '<!DOCTYPE html>\\n' + clone.outerHTML;
  }

  function enable() { startPicking(); parent.postMessage({ __llLayoutReady: true }, '*'); }
  function disable() { exitArranging(); stopPicking(); mode = 'off'; }
  window.addEventListener('message', function (e) {
    var d = e.data || {};
    if (d.__llLayoutEnable) enable();
    if (d.__llLayoutDisable) disable();
    if (d.__llLayoutAction) action(d.action);
    if (d.__llLayoutSave) parent.postMessage({ __llLayoutSaved: true, requestId: d.requestId, html: cleanHtml() }, '*');
  });

  var style = document.createElement('style');
  style.id = 'll-layout-editor-style';
  style.textContent = 'body.ll-ve-picking{cursor:crosshair!important}'
    + '.ll-pick-widen{position:absolute;right:-15px;top:-15px;width:28px;height:28px;border:2px solid #fff;border-radius:50%;background:#cc785c;color:#fff;box-shadow:0 2px 8px rgba(0,0,0,.3);cursor:pointer;pointer-events:auto;font-size:13px;line-height:1;}'
    + '.ll-pick-label{position:absolute;left:-2px;top:-26px;max-width:260px;padding:3px 8px;background:#cc785c;color:#fff;border-radius:5px 5px 5px 0;font:600 11px/16px system-ui;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;pointer-events:none;}'
    + '.ll-layout-card-active{outline:2px solid #cc785c!important;outline-offset:2px!important}'
    + '.ll-layout-movable{outline:2px dashed rgba(204,120,92,.85)!important;outline-offset:2px!important;cursor:grab!important}'
    + '.ll-layout-movable:hover{outline-style:solid!important}'
    + '.ll-layout-dragging{opacity:.45!important;cursor:grabbing!important}';
  document.head.appendChild(style);
  parent.postMessage({ __llLayoutBridgeLoaded: true }, '*');
})();
</script></head>`;

export function injectLayoutEditorBridge(html) {
  const source = String(html || '');
  return source.includes('</head>') ? source.replace('</head>', LAYOUT_EDITOR_SCRIPT) : source;
}

export function attachLayoutEditorBridge(iframe, { onReady, onUnavailable, onMode, onHistory } = {}) {
  const pending = new Map();
  let ready = false;
  let retryTimer = null;
  function enableWithRetry() {
    ready = false; let attempts = 0; clearInterval(retryTimer);
    const send = () => {
      if (ready || attempts >= 20) { clearInterval(retryTimer); retryTimer = null; if (!ready) onUnavailable?.(); return; }
      attempts += 1;
      iframe.contentWindow?.postMessage({ __llLayoutEnable: true }, '*');
    };
    send();
    retryTimer = setInterval(send, 150);
  }
  function onMessage(event) {
    if (event.source !== iframe.contentWindow) return;
    const d = event.data || {};
    if (d.__llLayoutBridgeLoaded) enableWithRetry();
    if (d.__llLayoutReady) { ready = true; clearInterval(retryTimer); retryTimer = null; onReady?.(); }
    if (d.__llLayoutMode) onMode?.(d);
    if (d.__llLayoutHistory) onHistory?.(d);
    if (d.__llLayoutSaved && pending.has(d.requestId)) { pending.get(d.requestId)(d.html); pending.delete(d.requestId); }
  }
  window.addEventListener('message', onMessage);
  return {
    enable: enableWithRetry,
    disable() { iframe.contentWindow?.postMessage({ __llLayoutDisable: true }, '*'); },
    action(action) { iframe.contentWindow?.postMessage({ __llLayoutAction: true, action }, '*'); },
    save() {
      const requestId = crypto.randomUUID();
      return new Promise((resolve, reject) => {
        pending.set(requestId, resolve);
        iframe.contentWindow?.postMessage({ __llLayoutSave: true, requestId }, '*');
        setTimeout(() => {
          if (!pending.has(requestId)) return;
          pending.delete(requestId);
          reject(new Error('The layout editor did not respond. Try reopening it.'));
        }, 10000);
      });
    },
    detach() { clearInterval(retryTimer); window.removeEventListener('message', onMessage); pending.clear(); },
  };
}
